import * as React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Phone from '../form/Phone';
import Email from '../form/Email';
import FirstName from '../form/FirstName';
import LastName from '../form/LastName';
import { config } from '_config';

export default function RenewalStep1({ state, onChange, onBlur, validated }) {
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <Form id="TrademarkForm" noValidate validated={validated}>
      <div className="question">
        {config.skin === 'v2-basic' && <h2>Serial Number</h2>}
        <div className="polaroid">
          <p className="primary-label">Enter your serial number or describe your mark</p>
          <div key={`inline-radio`} className="mb-3">
            <Form.Check
              inline
              label="Serial Number"
              name="serialProvided"
              type="radio"
              id="type1"
              value={'true'}
              checked={state.serialProvided === 'true'}
              onChange={handleChange}
            />
            <Form.Check
              inline
              label="Don't know it? Click here"
              name="serialProvided"
              id="type2"
              type="radio"
              value={'false'}
              checked={state.serialProvided === 'false'}
              onChange={handleChange}
            />
          </div>
          {state.serialProvided === 'true' ? (
            <div className="one-column-form">
              <Form.Group className="mb-3" controlId="serialNumber">
                <Form.Label column required>
                  Enter the serial number of the mark
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Enter the serial number of the mark"
                  onChange={handleChange}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) event.preventDefault();
                  }}
                  data-hj-allow
                  value={state.serialNumber ? state.serialNumber : ''}
                  pattern="^[0-9]+$"
                  maxLength="30"
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid Serial Number
                </Form.Control.Feedback>
              </Form.Group>{' '}
            </div>
          ) : (
            <div className="one-column-form">
              <Form.Group as={Row} className="mb-3" controlId="markDesc">
                <Form.Label column required>
                  If a name or slogan, provide the mark. If a logo, describe
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Enter mark or describe"
                  onChange={handleChange}
                  data-hj-allow
                  value={state.markDesc ? state.markDesc : ''}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a description
                </Form.Control.Feedback>
              </Form.Group>
              <FirstName
                id="markOwnerFirstName"
                label="Owner or the Mark First Name"
                value={state.markOwnerFirstName}
                onChange={handleChange}
              />
              <LastName
                id="markOwnerLastName"
                label="Owner or the Mark Last Name"
                value={state.markOwnerLastName}
                onChange={handleChange}
              />
              <Email
                id="markOwnerEmail"
                label="Owner Email Used in Your Application"
                state={state}
                onChange={handleChange}
                onBlur={onBlur}
              />
              <Phone
                id="markOwnerPhone"
                label="Owner Phone Number Used"
                state={state}
                onChange={handleChange}
              />
            </div>
          )}
        </div>
      </div>
    </Form>
  );
}
